var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "<div id=\"extra-parameters-"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\"></div>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"area-filter\"></div>\n<div id=\"time-filter\"></div>\n<div id=\"extra-parameters\"></div>\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layerIdsWithParameters") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":4,"column":83}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/filters/RootFiltersView.hbs
// module id = 2077
// module chunks = 0